// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"d3449974","248":"7b1ae194","277":"8a1fc806","298":"0b200cda","304":"8d24359a","431":"56721bec","653":"89ee6d23","776":"a016999f"}[chunkId] + ".chunk.js";
};